import { render, staticRenderFns } from "./PatientHistory.vue?vue&type=template&id=531312f7&scoped=true"
import script from "./PatientHistory.vue?vue&type=script&lang=js"
export * from "./PatientHistory.vue?vue&type=script&lang=js"
import style0 from "./PatientHistory.vue?vue&type=style&index=0&id=531312f7&prod&scoped=true&lang=css"
import style1 from "./PatientHistory.vue?vue&type=style&index=1&id=531312f7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531312f7",
  null
  
)

export default component.exports